import React from 'react';

interface BrandOverlayProps {
  text?: string;
  link?: string;
  className?: string;
  style?: React.CSSProperties;
  opacity?: number;
  fontSize?: string;
  color?: string;
  position?: 'bottom-right' | 'bottom-left' | 'bottom-center' | 'top-left' | 'top-right';
  hideOnMobile?: boolean;
}

const BrandOverlay: React.FC<BrandOverlayProps> = ({
  text = 'UOC tech made this website',
  link,
  className = '',
  style = {},
  opacity = 0.4,
  fontSize = '14px',
  color = '#333333',
  position = 'bottom-right',
  hideOnMobile = false,
}) => {
  const getPositionStyles = () => {
    const baseStyles = {
      position: 'fixed' as const,
      zIndex: 9999,
    };

    switch (position) {
      case 'bottom-left':
        return { ...baseStyles, bottom: '20px', left: '20px' };
      case 'bottom-center':
        return { ...baseStyles, bottom: '20px', left: '50%', transform: 'translateX(-50%)' };
      case 'top-left':
        return { ...baseStyles, top: '20px', left: '20px' };
      case 'top-right':
        return { ...baseStyles, top: '20px', right: '20px' };
      case 'bottom-right':
      default:
        return { ...baseStyles, bottom: '20px', right: '20px' };
    }
  };

  const overlayStyles: React.CSSProperties = {
    ...getPositionStyles(),
    opacity,
    fontSize,
    color,
    fontFamily: 'Arial, sans-serif',
    pointerEvents: link ? 'auto' : 'none',
    userSelect: 'none',
    fontStyle: 'italic',
    // textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
    ...style,
  };

  // Hide on mobile if specified
  if (hideOnMobile) {
    overlayStyles.display = 'block';
    // Can adjust the breakpoint as needed
    const mediaQuery = '(max-width: 768px)';
    if (window.matchMedia(mediaQuery).matches) {
      overlayStyles.display = 'none';
    }
  }

  const content = (
    <div className={className} style={overlayStyles}>
      {text}
    </div>
  );

  if (link) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        {content}
      </a>
    );
  }

  return content;
};

export default BrandOverlay;
